import { createMergeReducer } from '../utils/reducer'

export type TitleIdToPageLink = {
  [titleId: string]: string | undefined
}

export const reducer = createMergeReducer(
  t => t.pageLink,
  {} as TitleIdToPageLink
)
